import { useState, useEffect, useRef } from 'react';

export const useLocalStorageState = (
	key,
	defaultValue = '',
	{ serialize = JSON.stringify, deserialize = JSON.parse } = {}
	//For the case we would like to use another serialization/de-serialization method.
) => {
	const [state, setState] = useState(() => {
		const valueInLocalStorage = window.localStorage.getItem(key);
		if (valueInLocalStorage) {
			// the try/catch is here in case the localStorage value was set before we had the serialization in place
			try {
				return deserialize(valueInLocalStorage);
			} catch (error) {
				window.localStorage.removeItem(key);
			}
		}
		return defaultValue;
	});

	const prevKeyRef = useRef(key);
	//For the case the has been changed

	useEffect(() => {
		const prevKey = prevKeyRef.current;
		if (prevKey !== key) {
			window.localStorage.removeItem(prevKey);
		}
		prevKeyRef.current = key;
		if(key){
			window.localStorage.setItem(key, serialize(state));
		}
	}, [key, state, serialize]);

	return [state, setState];
};
